import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { style: {"font-weight":"bold","border-right":"1px solid #dddddd"} }
const _hoisted_13 = {
  key: 0,
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_14 = {
  key: 1,
  class: "text-right"
}
const _hoisted_15 = {
  key: 2,
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_16 = {
  key: 3,
  class: "text-right"
}
const _hoisted_17 = {
  key: 4,
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"},
  class: "text-right"
}
const _hoisted_18 = {
  key: 5,
  class: "text-right",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_19 = {
  key: 6,
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"},
  class: "text-right"
}
const _hoisted_20 = {
  key: 7,
  class: "text-right",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_21 = {
  key: 8,
  class: "text-right"
}
const _hoisted_22 = {
  key: 9,
  class: "text-right"
}
const _hoisted_23 = {
  key: 10,
  class: "text-right"
}
const _hoisted_24 = {
  key: 11,
  class: "text-right"
}
const _hoisted_25 = {
  key: 12,
  class: "text-right"
}
const _hoisted_26 = {
  key: 13,
  class: "text-right"
}
const _hoisted_27 = {
  key: 14,
  class: "text-right"
}
const _hoisted_28 = {
  key: 15,
  class: "text-right"
}
const _hoisted_29 = {
  key: 16,
  class: "text-right"
}
const _hoisted_30 = {
  key: 17,
  class: "text-right"
}
const _hoisted_31 = {
  key: 18,
  class: "text-right"
}
const _hoisted_32 = {
  key: 19,
  class: "text-right"
}
const _hoisted_33 = {
  key: 20,
  class: "text-right",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_34 = {
  key: 21,
  class: "text-right",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_35 = {
  key: 0,
  class: "text-center"
}
const _hoisted_36 = {
  key: 1,
  class: "text-center"
}
const _hoisted_37 = {
  key: 2,
  class: "text-left"
}
const _hoisted_38 = {
  key: 3,
  class: "text-left"
}
const _hoisted_39 = {
  key: 4,
  class: "text-left"
}
const _hoisted_40 = {
  key: 5,
  class: "text-left"
}
const _hoisted_41 = {
  key: 6,
  class: "text-right"
}
const _hoisted_42 = {
  key: 7,
  class: "text-right"
}
const _hoisted_43 = {
  key: 8,
  class: "text-right"
}
const _hoisted_44 = {
  key: 9,
  class: "text-right"
}
const _hoisted_45 = {
  key: 10,
  class: "text-right"
}
const _hoisted_46 = {
  key: 11,
  class: "text-right"
}
const _hoisted_47 = {
  key: 12,
  class: "text-center"
}
const _hoisted_48 = {
  key: 13,
  class: "text-center"
}
const _hoisted_49 = { class: "text-center pl-2 py-0" }
const _hoisted_50 = {
  key: 14,
  class: "text-center pl-2 py-0",
  cols: "1"
}
const _hoisted_51 = {
  key: 15,
  class: "text-center pl-2 py-0",
  cols: "1"
}
const _hoisted_52 = {
  class: "text-center",
  style: {"border-left":"1px #ededed solid"}
}
const _hoisted_53 = { style: {"background-color":"white","border-radius":"25px"} }
const _hoisted_54 = {
  key: 0,
  class: "text-center"
}
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 2 }
const _hoisted_57 = { key: 3 }
const _hoisted_58 = {
  key: 2,
  class: "text-right"
}
const _hoisted_59 = { class: "text-center pl-2 py-0" }
const _hoisted_60 = {
  class: "text-center",
  style: {"border-left":"1px #ededed solid"}
}
const _hoisted_61 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { style: {"border-right":"1px solid #dddddd"} }
const _hoisted_67 = {
  key: 0,
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_68 = { key: 1 }
const _hoisted_69 = {
  key: 2,
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_70 = { style: {"border-right":"1px solid #dddddd"} }
const _hoisted_71 = {
  key: 3,
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_72 = {
  key: 4,
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_73 = {
  key: 5,
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_74 = {
  key: 6,
  style: {"border-right":"1px solid #dddddd"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "11",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _cache[53] || (_cache[53] = _createElementVNode("h2", null, "Avoirs à établir (AAE) sur factures clients", -1)),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps(props, {
                            size: "large",
                            class: "ml-2",
                            icon: "$oss-help"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[49] || (_cache[49] = _createElementVNode("p", { class: "mb-0" }, " Sont affichés les factures et avoirs non lettrés, contenus dans les c/411. ", -1)),
                          _cache[50] || (_cache[50] = _createElementVNode("p", { class: "mb-0" }, " Les documents et paiements en attente de validation ou de lettrage ne sont pas pris en compte. (à régulariser dans le contrôle balance âgée) ", -1)),
                          _cache[51] || (_cache[51] = _createElementVNode("p", { class: "mb-0" }, " Sont affichés les AAE (c/4198), lettrés ou non lettrés, de l'exercice sélectionné. ", -1)),
                          _cache[52] || (_cache[52] = _createElementVNode("p", { class: "mb-0" }, " Effectuées avec les différents outils bobbee ou avec des ODs manuelles. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        class: "btn",
                        size: "x-small",
                        icon: "$oss-chat"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _cache[54] || (_cache[54] = _createElementVNode("span", null, "Message", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createAdjustmentsData())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[55] || (_cache[55] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: _ctx.closedPeriod || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[56] || (_cache[56] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.createAdjustmentsData('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.createAdjustmentsData('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[57] || (_cache[57] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[60] || (_cache[60] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[59] || (_cache[59] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[58] || (_cache[58] = [
                                  _createTextVNode("Afficher l'activité")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[61] || (_cache[61] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[62] || (_cache[62] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.closedPeriod)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          large: "",
                          class: "mr-2 mb-1",
                          color: "primary"
                        }, {
                          default: _withCtx(() => _cache[63] || (_cache[63] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[64] || (_cache[64] = _createElementVNode("h3", null, "Période clôturée", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.globalAmounts || !_ctx.globalAmounts.grossAmountSigned)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => _cache[65] || (_cache[65] = [
                            _createElementVNode("h4", null, "Aucune facture ou avoir non lettré", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.customers.length)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 2,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "justify-space-between"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "auto",
                              class: "d-flex justify-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, null, {
                                  default: _withCtx(() => _cache[66] || (_cache[66] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Total créances calculées au :", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "d-flex justify-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h5", null, [
                                      _createVNode(_component_oss_date_picker, {
                                        modelValue: _ctx.selectedDate,
                                        "onUpdate:modelValue": [
                                          _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedDate) = $event)),
                                          _cache[11] || (_cache[11] = ($event: any) => {
                                            _ctx.expand = false;
                                            _ctx.expand4 = false;
                                        })
                                        ],
                                        textFieldReadOnly: false,
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "ma-auto text-center" }, {
                              default: _withCtx(() => [
                                (_ctx.globalAmounts.grossAmountSigned)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_4, " T.T.C. : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.globalAmounts.grossAmountSigned, {
                                        currency: "",
                                        DC: true,
                                    })), 1))
                                  : (_openBlock(), _createElementBlock("h5", _hoisted_5, "T.T.C. : -"))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "ma-auto text-center" }, {
                              default: _withCtx(() => [
                                (_ctx.globalAmounts.netAmountSigned)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_6, " H.T. : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.globalAmounts.netAmountSigned, {
                                        currency: "",
                                        DC: true,
                                    })), 1))
                                  : (_openBlock(), _createElementBlock("h5", _hoisted_7, "H.T. : -"))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "ma-auto text-center" }, {
                              default: _withCtx(() => [
                                (_ctx.globalAmounts.vatAmountSigned)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_8, " T.V.A. : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.globalAmounts.vatAmountSigned, {
                                        currency: "",
                                        DC: true,
                                    })), 1))
                                  : (_openBlock(), _createElementBlock("h5", _hoisted_9, "T.V.A. : -"))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "ma-auto text-center" }, {
                              default: _withCtx(() => [
                                (_ctx.globalAmounts.cumulatedCreditNotes)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_10, " AAE émis : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.globalAmounts.cumulatedCreditNotes, {
                                        currency: "",
                                        DC: true,
                                    })), 1))
                                  : (_openBlock(), _createElementBlock("h5", _hoisted_11, "AAE émis : -"))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                              default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                _createTextVNode(" $check_circle ")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                            _ctx.customersExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.customersExpand = !_ctx.customersExpand)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                          default: _withCtx(() => [
                            (_ctx.customers.length)
                              ? (_openBlock(), _createBlock(_component_v_card, {
                                  key: 0,
                                  elevation: "0",
                                  style: {"background-color":"white","border-radius":"25px"},
                                  class: "py-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { class: "pa-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.doubtfullAccountsHeaders,
                                          items: _ctx.customers,
                                          "sort-by": [{ key: 'customer.name', order: 'asc' }],
                                          loading: _ctx.loading,
                                          class: "table",
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          "no-data": _withCtx(() => _cache[68] || (_cache[68] = [
                                            _createTextVNode("Aucune facture échue")
                                          ])),
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_12, _toDisplayString(props.item.customer.name), 1),
                                              (props.item.netAmountSigned)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.netAmountSigned,
                                                        { currency: "", DC: true },
                                                    )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_14, "-")),
                                              (props.item.vatAmountSigned)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.vatAmountSigned,
                                                        { currency: "", DC: true },
                                                    )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_16, "-")),
                                              (
                                                    props.item.grossAmountSigned &&
                                                    props.item.documents
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.grossAmountSigned,
                                                        { currency: "", DC: true },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item,
                                                            ' : toutes périodes',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_18, " - ")),
                                              (
                                                    props.item.cumulatedCreditNotes &&
                                                    props.item.existingCreditNotes
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.cumulatedCreditNotes,
                                                        { currency: "", DC: true },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openCreditNotesList(
                                                            props.item.existingCreditNotes,
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_20, " - ")),
                                              (
                                                    props.item.period31 &&
                                                    props.item.period31.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period31.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period31,
                                                            ' - de 31 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_22, "-")),
                                              (
                                                    props.item.period60 &&
                                                    props.item.period60.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period60.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period60,
                                                            ' - de 60 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_24, "-")),
                                              (
                                                    props.item.period90 &&
                                                    props.item.period90.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period90.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period90,
                                                            ' - de 90 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_26, "-")),
                                              (
                                                    props.item.period120 &&
                                                    props.item.period120.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period120.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period120,
                                                            ' - de 120 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_28, "-")),
                                              (
                                                    props.item.period180 &&
                                                    props.item.period180.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period180.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period180,
                                                            ' - de 180 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_30, "-")),
                                              (
                                                    props.item.period365 &&
                                                    props.item.period365.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period365.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period365,
                                                            ' - de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_32, "-")),
                                              (
                                                    props.item.periodMore &&
                                                    props.item.periodMore.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.periodMore.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.periodMore,
                                                            ' + de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_34, " - "))
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items", "loading"]),
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    (_ctx.closedPeriod || _ctx.validated)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          rounded: "",
                                                          disabled: "",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                            _createTextVNode(" OD ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          rounded: "",
                                                          class: "btn btn_blue",
                                                          onClick: _cache[13] || (_cache[13] = ($event: any) => {
                                                    _ctx.createAdjustmentsData();
                                                    _ctx.miscellanousOperationData = undefined;
                                                    _ctx.miscellaneousOperationDialog = true;
                                                }),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                            _createTextVNode(" OD ")
                                                          ])),
                                                          _: 1
                                                        })),
                                                    (_ctx.closedPeriod || _ctx.validated)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 2,
                                                          disabled: "",
                                                          rounded: "",
                                                          class: "btn btn_blue",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                            _createTextVNode(" Enregistrer ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 3,
                                                          rounded: "",
                                                          class: "btn btn_blue",
                                                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                            _createTextVNode(" Enregistrer ")
                                                          ])),
                                                          _: 1
                                                        })),
                                                    (_ctx.closedPeriod)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 4,
                                                          rounded: "",
                                                          class: "btn btn_blue",
                                                          disabled: "",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[73] || (_cache[73] = [
                                                            _createTextVNode(" Valider ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (!_ctx.validated)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 5,
                                                            rounded: "",
                                                            class: "btn btn_blue",
                                                            onClick: _cache[15] || (_cache[15] = ($event: any) => {
                                                    _ctx.validated = !_ctx.validated;
                                                    _ctx.adjustmentsExpand = false;
                                                    _ctx.createAdjustmentsData('VALIDATE');
                                                }),
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[74] || (_cache[74] = [
                                                              _createTextVNode(" Valider ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 6,
                                                            rounded: "",
                                                            class: "btn btn_blue",
                                                            onClick: _cache[16] || (_cache[16] = ($event: any) => {
                                                    _ctx.validated = !_ctx.validated;
                                                    _ctx.createAdjustmentsData('UPDATE');
                                                }),
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[75] || (_cache[75] = [
                                                              _createTextVNode(" Invalider ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.customersExpand]
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.periodDocuments.length > 0)
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                      key: 3,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expand_transition, null, {
                          default: _withCtx(() => [
                            (_ctx.periodDocuments.length > 0)
                              ? _withDirectives((_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 0,
                                  class: "pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "px-5 pt-3" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("h3", null, _toDisplayString(_ctx.periodsCustomer.name) + " - Factures échues depuis " + _toDisplayString(_ctx.selectedPeriod), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_text, { class: "py-4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.periodDocumentsHeaders,
                                          items: _ctx.periodDocuments,
                                          "sort-by": [
                                        { key: 'date' },
                                        { key: 'netAmountSigned' },
                                        { key: 'grossAmountSigned' },
                                        { key: 'dueDate' },
                                        { key: 'name' },
                                    ],
                                          loading: _ctx.loading,
                                          class: "table",
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          "no-data": _withCtx(() => _cache[76] || (_cache[76] = [
                                            _createTextVNode("Aucune facture échue sur la période")
                                          ])),
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (props.item.date)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_36, "-")),
                                              (props.item.text)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(props.item.text), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_38, "-")),
                                              (props.item.invoiceNumber)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString(props.item.invoiceNumber), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_40, "-")),
                                              (props.item.doc7and6)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.doc7and6, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_42, "-")),
                                              (props.item.doc445)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.doc445, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_44, "-")),
                                              (props.item.doc411)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.doc411, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_46, "-")),
                                              (props.item.dueDate)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_47, _toDisplayString(_ctx.formatDate(props.item.dueDate)), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_48, "-")),
                                              _createElementVNode("td", _hoisted_49, [
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: "$remove_red_eye",
                                                  onClick: ($event: any) => (_ctx.openDocument(props.item))
                                                }, null, 8, ["onClick"])
                                              ]),
                                              (
                                                    props.item.cctiAuditCheckResult &&
                                                    props.item.cctiAuditCheckResult.results &&
                                                    props.item.cctiAuditCheckResult.results[0] &&
                                                    props.item.cctiAuditCheckResult.results[0].date
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_50, _toDisplayString(_ctx.formatDate(
                                                        props.item.cctiAuditCheckResult.results[0]
                                                            .date,
                                                    )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_51, [
                                                    (_ctx.accountingPeriod.closed)
                                                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                          key: 0,
                                                          icon: "$spellcheck",
                                                          disabled: "",
                                                          color: "primary"
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$spellcheck",
                                                      onClick: ($event: any) => (
                                                        _ctx.openCreditNoteDialog(
                                                            props.item,
                                                            _ctx.periodsCustomer,
                                                        )
                                                    )
                                                    }, null, 8, ["onClick"])
                                                  ])),
                                              _createElementVNode("td", _hoisted_52, [
                                                _createVNode(_component_v_menu, { "offset-y": "" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                                      class: "mx-1",
                                                      color: "secondary"
                                                    }), null, 16)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list, null, {
                                                      default: _withCtx(() => [
                                                        (_ctx.accountingPeriod.closed)
                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                              key: 0,
                                                              disabled: ""
                                                            }, {
                                                              append: _withCtx(() => [
                                                                _createVNode(_component_v_icon, null, {
                                                                  default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                                    _createTextVNode("$spellcheck")
                                                                  ])),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, null, {
                                                                  default: _withCtx(() => _cache[77] || (_cache[77] = [
                                                                    _createTextVNode(" Créer ou modifier l'avoir à établir ")
                                                                  ])),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_list_item, {
                                                              key: 1,
                                                              onClick: ($event: any) => (
                                                                _ctx.openCreditNoteDialog(
                                                                    props.item,
                                                                    _ctx.periodsCustomer,
                                                                )
                                                            )
                                                            }, {
                                                              append: _withCtx(() => [
                                                                _createVNode(_component_v_icon, {
                                                                  color: _ctx.actionColor(props.item)
                                                                }, {
                                                                  default: _withCtx(() => _cache[80] || (_cache[80] = [
                                                                    _createTextVNode(" $spellcheck ")
                                                                  ])),
                                                                  _: 2
                                                                }, 1032, ["color"])
                                                              ]),
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, null, {
                                                                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                                    _createTextVNode(" Créer ou modifier l'avoir à établir ")
                                                                  ])),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"])),
                                                        (
                                                                props.item.cctiAuditCheckResult &&
                                                                props.item.cctiAuditCheckResult.id
                                                            )
                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                              key: 2,
                                                              onClick: ($event: any) => (
                                                                _ctx.deleteAuditCheckResult(
                                                                    props.item.cctiAuditCheckResult
                                                                        .id,
                                                                )
                                                            )
                                                            }, {
                                                              append: _withCtx(() => [
                                                                _createVNode(_component_v_icon, { size: "small" }, {
                                                                  default: _withCtx(() => _cache[82] || (_cache[82] = [
                                                                    _createTextVNode(" $oss-trash ")
                                                                  ])),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, null, {
                                                                  default: _withCtx(() => _cache[81] || (_cache[81] = [
                                                                    _createTextVNode("Supprimer l'avoir à établir")
                                                                  ])),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"]))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items", "loading"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 512)), [
                                  [_vShow, _ctx.expand]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, _ctx.expand]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.existingCreditNotes.length > 0)
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                      key: 4,
                      elevation: "0",
                      class: "px-4 my-4",
                      style: {"border-radius":"25px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_v_expand_transition, null, {
                            default: _withCtx(() => [
                              (_ctx.existingCreditNotes.length > 0)
                                ? _withDirectives((_openBlock(), _createBlock(_component_v_card_text, {
                                    key: 0,
                                    class: "pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { class: "px-5 pt-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h3", null, _toDisplayString(_ctx.creditNotesCustomer.name) + " - Avoirs à établir", 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_card_text, { class: "py-4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_data_table, {
                                            headers: _ctx.creditNotesListHeaders,
                                            items: _ctx.existingCreditNotes,
                                            "sort-by": [
                                            { key: 'date' },
                                            { key: 'name' },
                                            { key: 'netAmountSigned' },
                                            { key: 'grossAmountSigned' },
                                        ],
                                            loading: _ctx.loading,
                                            class: "table",
                                            style: {"border":"1px #ededed solid"}
                                          }, {
                                            "no-data": _withCtx(() => _cache[83] || (_cache[83] = [
                                              _createTextVNode("Aucun passage en perte irrécouvrable précédente")
                                            ])),
                                            item: _withCtx((props) => [
                                              _createElementVNode("tr", null, [
                                                (props.item.date)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_55, "-")),
                                                (props.item.name)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(props.item.name), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_57)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item
                                                        .accountingLines, (al, index) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                    (
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '7',
                                                            ) &&
                                                            al.amountSigned
                                                        )
                                                      ? (_openBlock(), _createElementBlock("td", {
                                                          key: index,
                                                          class: "text-right"
                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )), 1))
                                                      : _createCommentVNode("", true),
                                                    (
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '445',
                                                            ) &&
                                                            al.amountSigned &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '7',
                                                            ) &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '41',
                                                            )
                                                        )
                                                      ? (_openBlock(), _createElementBlock("td", {
                                                          key: index,
                                                          class: "text-right"
                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )), 1))
                                                      : (
                                                            props.item.accountingLines.length ===
                                                                2 &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '41',
                                                            )
                                                        )
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_58, " - "))
                                                        : _createCommentVNode("", true),
                                                    (
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '41',
                                                            ) &&
                                                            al.amountSigned
                                                        )
                                                      ? (_openBlock(), _createElementBlock("td", {
                                                          key: index,
                                                          class: "text-right"
                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )), 1))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                }), 128)),
                                                _createElementVNode("td", _hoisted_59, [
                                                  _createVNode(_component_v_btn_icon, {
                                                    icon: "$remove_red_eye",
                                                    onClick: ($event: any) => (_ctx.openDocument(props.item))
                                                  }, null, 8, ["onClick"])
                                                ]),
                                                _createElementVNode("td", _hoisted_60, [
                                                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                                        class: "mx-1",
                                                        color: "secondary"
                                                      }), null, 16)
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list, null, {
                                                        default: _withCtx(() => [
                                                          (
                                                                    props.item.isResultOf &&
                                                                    props.item.isResultOf.id &&
                                                                    (!_ctx.accountingPeriod ||
                                                                        !_ctx.accountingPeriod.closed)
                                                                )
                                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                key: 0,
                                                                onClick: ($event: any) => (
                                                                    _ctx.deleteAuditCheckResult(
                                                                        props.item.isResultOf.id,
                                                                    )
                                                                )
                                                              }, {
                                                                append: _withCtx(() => [
                                                                  _createVNode(_component_v_icon, { size: "small" }, {
                                                                    default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                                      _createTextVNode(" $oss-trash ")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                                      _createTextVNode("Supprimer l'avoir à établir")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]))
                                                            : (_openBlock(), _createBlock(_component_v_list_item, {
                                                                key: 1,
                                                                disabled: ""
                                                              }, {
                                                                append: _withCtx(() => [
                                                                  _createVNode(_component_v_icon, { size: "small" }, {
                                                                    default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                                      _createTextVNode(" $oss-trash ")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                                      _createTextVNode(" Supprimer l'avoir à établir ")
                                                                    ])),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 1
                                                              }))
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["headers", "items", "loading"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 512)), [
                                    [_vShow, _ctx.expand4]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, _ctx.expand4]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[88] || (_cache[88] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Grand livre c/411", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.generalLedgerExpand411
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.generalLedgerExpand411 = !_ctx.generalLedgerExpand411)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period, x) => {
                          return (_openBlock(), _createBlock(_component_v_card, {
                            key: x,
                            style: {"background-color":"white","border-radius":"25px","padding":"10px"},
                            class: "my-5"
                          }, {
                            default: _withCtx(() => [
                              (period.period === 'N')
                                ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Solde " + _toDisplayString(period.period) + " : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance411NL, {
                                        currency: "",
                                        DC: true,
                                    })), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Solde " + _toDisplayString(period.period) + " : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance411NLNextPeriod, {
                                        currency: "",
                                        DC: true,
                                    })), 1)
                                    ]),
                                    _: 2
                                  }, 1024)),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger411 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_GeneralLedger, {
                                            companyId: _ctx.companyId,
                                            accountingPeriodId: period.id,
                                            thirdPartyType: '411',
                                            inNm1: false,
                                            onQueryDone: period.onQueryDone
                                          }, null, 8, ["companyId", "accountingPeriodId", "onQueryDone"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.generalLedgerExpand411]
                    ])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.show411NL || _ctx.show411NLNextPeriod]
                ]),
                _withDirectives(_createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => [
                                (_ctx.items.accountableAccountsRoot.length)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_61, " Grand livre c/" + _toDisplayString(_ctx.getTextFromStringArray(_ctx.items.accountableAccountsRoot)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.generalLedgerExpand = !_ctx.generalLedgerExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period, y) => {
                          return (_openBlock(), _createBlock(_component_v_card, {
                            key: y,
                            style: {"background-color":"white","border-radius":"25px","padding":"10px"},
                            class: "my-5"
                          }, {
                            default: _withCtx(() => [
                              (period.period === 'N')
                                ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Solde " + _toDisplayString(period.period) + " : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance4198NL, {
                                        currency: "",
                                        DC: true,
                                    })), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Solde " + _toDisplayString(period.period) + " : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance4198NLNextPeriod, {
                                        currency: "",
                                        DC: true,
                                    })), 1)
                                    ]),
                                    _: 2
                                  }, 1024)),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger411 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_GeneralLedger, {
                                            companyId: _ctx.companyId,
                                            accountingPeriodId: period.id,
                                            accountableAccountFilter: 
                                                _ctx.items.accountableAccountsRoot
                                            ,
                                            inNm1: false,
                                            onQueryDone: period.onQueryDone2,
                                            ref_for: true,
                                            ref: "generalLedger",
                                            enableAuditedAccountableAccounts: true
                                          }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "onQueryDone"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_spacer),
                                              (_ctx.closedPeriod || _ctx.validated)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 0,
                                                    rounded: "",
                                                    disabled: "",
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[89] || (_cache[89] = [
                                                      _createTextVNode(" OD ")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 1,
                                                    rounded: "",
                                                    class: "btn btn_blue",
                                                    onClick: _cache[19] || (_cache[19] = ($event: any) => {
                                                    _ctx.createAdjustmentsData();
                                                    _ctx.miscellanousOperationData = undefined;
                                                    _ctx.miscellaneousOperationDialog = true;
                                                }),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[90] || (_cache[90] = [
                                                      _createTextVNode(" OD ")
                                                    ])),
                                                    _: 1
                                                  }))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024),
                              _cache[91] || (_cache[91] = _createElementVNode("br", null, null, -1))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.generalLedgerExpand]
                    ])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.show4198NL || _ctx.totalBalance4198NLNextPeriod]
                ]),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                      key: 5,
                      connectedDocuments: _ctx.connectedDocuments,
                      companyId: _ctx.companyId,
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      onUnlinkedDocument: _cache[20] || (_cache[20] = ($event: any) => (_ctx.unlinkDocument($event))),
                      onShowLinkedDocument: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showLinkedDocument($event)))
                    }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                      key: 6,
                      results: _ctx.results,
                      companyId: _ctx.companyId
                    }, null, 8, ["results", "companyId"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[92] || (_cache[92] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.commentExpand = !_ctx.commentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.commentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "expand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { class: "pt-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: _ctx.comment,
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.comment) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          "auto-grow": "",
                                          style: {"border":"1px #ededed solid"},
                                          outlined: ""
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              rounded: "",
                                              disabled: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[93] || (_cache[93] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[24] || (_cache[24] = ($event: any) => {
                                            _ctx.createAdjustmentsData();
                                            _ctx.miscellanousOperationData = undefined;
                                            _ctx.miscellaneousOperationDialog = true;
                                        }),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[94] || (_cache[94] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            })),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[95] || (_cache[95] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 3,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[96] || (_cache[96] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            })),
                                        (_ctx.closedPeriod)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 4,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              disabled: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[97] || (_cache[97] = [
                                                _createTextVNode(" Valider ")
                                              ])),
                                              _: 1
                                            }))
                                          : (!_ctx.validated)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 5,
                                                rounded: "",
                                                class: "btn btn_blue",
                                                onClick: _cache[26] || (_cache[26] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.adjustmentsExpand = false;
                                            _ctx.createAdjustmentsData('VALIDATE');
                                        }),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[98] || (_cache[98] = [
                                                  _createTextVNode(" Valider ")
                                                ])),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 6,
                                                rounded: "",
                                                class: "btn btn_blue",
                                                onClick: _cache[27] || (_cache[27] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.createAdjustmentsData('UPDATE');
                                        }),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[99] || (_cache[99] = [
                                                  _createTextVNode(" Invalider ")
                                                ])),
                                                _: 1
                                              }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[100] || (_cache[100] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.shortCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "expand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { class: "pt-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: _ctx.shortComment,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.shortComment) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          "auto-grow": "",
                                          style: {"border":"1px #ededed solid"},
                                          outlined: ""
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              rounded: "",
                                              disabled: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[101] || (_cache[101] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[30] || (_cache[30] = ($event: any) => {
                                            _ctx.createAdjustmentsData();
                                            _ctx.miscellanousOperationData = undefined;
                                            _ctx.miscellaneousOperationDialog = true;
                                        }),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            })),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 3,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[104] || (_cache[104] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            })),
                                        (_ctx.closedPeriod)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 4,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              disabled: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[105] || (_cache[105] = [
                                                _createTextVNode(" Valider ")
                                              ])),
                                              _: 1
                                            }))
                                          : (!_ctx.validated)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 5,
                                                rounded: "",
                                                class: "btn btn_blue",
                                                onClick: _cache[32] || (_cache[32] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.adjustmentsExpand = false;
                                            _ctx.createAdjustmentsData('VALIDATE');
                                        }),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[106] || (_cache[106] = [
                                                  _createTextVNode(" Valider ")
                                                ])),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 6,
                                                rounded: "",
                                                class: "btn btn_blue",
                                                onClick: _cache[33] || (_cache[33] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.createAdjustmentsData('UPDATE');
                                        }),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[107] || (_cache[107] = [
                                                  _createTextVNode(" Invalider ")
                                                ])),
                                                _: 1
                                              }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.creditNoteDialog)
                  ? (_openBlock(), _createBlock(_component_v_dialog, {
                      key: 7,
                      modelValue: _ctx.creditNoteDialog,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.creditNoteDialog) = $event)),
                      width: "90%",
                      class: "justify-space-around"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "primary",
                              class: "elevation-0"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.selectedCustomer && _ctx.selectedCustomer.name)
                                  ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.selectedCustomer.name) + " - Passer un avoir à établir (AAE) ", 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn_icon, {
                                  icon: "$close",
                                  onClick: _ctx.quitCreditNoteDialog
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window, {
                              modelValue: _ctx.step,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.step) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_window_item, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "3" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.invoice && _ctx.invoice.date)
                                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_62, "Créance"))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "3" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.invoice && _ctx.invoice.date)
                                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_63, _toDisplayString(_ctx.formatDate(_ctx.invoice.date)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "3" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.invoice.doc7and6)
                                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_64, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.invoice.doc7and6, {
                                                            currency: "",
                                                            DC: true,
                                                        })) + " HT ", 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "3" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.invoice.doc445)
                                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_65, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.invoice.doc445, {
                                                            currency: "",
                                                            DC: true,
                                                        })) + " TVA ", 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_text, null, {
                                          default: _withCtx(() => [
                                            _cache[110] || (_cache[110] = _createElementVNode("h2", { class: "pb-4" }, null, -1)),
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "3" }, {
                                                  default: _withCtx(() => _cache[108] || (_cache[108] = [
                                                    _createElementVNode("h3", { style: {} }, "Avoir à établir", -1)
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "3" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.creditNote.date)), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "3" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.invoice.doc7and6)
                                                      ? (_openBlock(), _createBlock(_component_oss_text_field, {
                                                          key: 0,
                                                          modelValue: _ctx.selected7and6AmountSigned.amount,
                                                          "onUpdate:modelValue": [
                                                            _cache[34] || (_cache[34] = ($event: any) => ((_ctx.selected7and6AmountSigned.amount) = $event)),
                                                            _cache[35] || (_cache[35] = ($event: any) => (_ctx.calculateAdjustments()))
                                                          ],
                                                          rules: [
                                                        (v) =>
                                                            v <= -_ctx.invoice.doc7and6 ||
                                                            'Valeur maximale ' +
                                                                [-_ctx.invoice.doc7and6],
                                                        (v) => v >= 0 || 'Valeur minimale ' + [0],
                                                    ],
                                                          label: "HT",
                                                          outlined: "",
                                                          dense: ""
                                                        }, null, 8, ["modelValue", "rules"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "3" }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.invoice.doc445)
                                                      ? (_openBlock(), _createBlock(_component_oss_text_field, {
                                                          key: 0,
                                                          modelValue: _ctx.selected445AmountSigned.amount,
                                                          "onUpdate:modelValue": [
                                                            _cache[36] || (_cache[36] = ($event: any) => ((_ctx.selected445AmountSigned.amount) = $event)),
                                                            _cache[37] || (_cache[37] = ($event: any) => (_ctx.calculateAdjustments()))
                                                          ],
                                                          rules: [
                                                        (v) =>
                                                            v <= -_ctx.invoice.doc445 ||
                                                            'Valeur maximale ' + [-_ctx.invoice.doc445],
                                                        (v) => v >= 0 || 'Valeur minimale ' + [0],
                                                    ],
                                                          label: "TVA",
                                                          outlined: "",
                                                          dense: ""
                                                        }, null, 8, ["modelValue", "rules"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (
                                                _ctx.creditNote &&
                                                _ctx.creditNote.accountingLines &&
                                                _ctx.creditNote.accountingLines.create
                                            )
                                              ? (_openBlock(), _createBlock(_component_v_data_table, {
                                                  key: 0,
                                                  headers: _ctx.creditNoteHeaders,
                                                  items: _ctx.creditNote.accountingLines.create,
                                                  loading: _ctx.loading,
                                                  class: "table",
                                                  style: {"border":"1px #ededed solid"}
                                                }, {
                                                  "no-data": _withCtx(() => _cache[109] || (_cache[109] = [
                                                    _createTextVNode("Aucune note de credit à établir")
                                                  ])),
                                                  item: _withCtx((props) => [
                                                    _createElementVNode("tr", null, [
                                                      _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.formatDate(props.item.date)), 1),
                                                      (
                                                            props.item.accountableAccount &&
                                                            props.item.accountableAccount.connect &&
                                                            props.item.accountableAccount.connect
                                                                .uniqueName.name
                                                        )
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_67, _toDisplayString(props.item.accountableAccount.connect
                                                                .uniqueName.name), 1))
                                                        : (
                                                            props.item.accountableAccount &&
                                                            props.item.accountableAccount.name
                                                        )
                                                          ? (_openBlock(), _createElementBlock("td", _hoisted_68, _toDisplayString(props.item.accountableAccount.connect
                                                                .uniqueName.name), 1))
                                                          : (_openBlock(), _createElementBlock("td", _hoisted_69)),
                                                      _createElementVNode("td", _hoisted_70, _toDisplayString(props.item.wording), 1),
                                                      (
                                                            props.item.amountSigned &&
                                                            props.item.amountSigned > 0
                                                        )
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_71, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(props.item.amountSigned),
                                                                undefined,
                                                            )), 1))
                                                        : (_openBlock(), _createElementBlock("td", _hoisted_72)),
                                                      (
                                                            props.item.amountSigned &&
                                                            props.item.amountSigned < 0
                                                        )
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_73, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(props.item.amountSigned),
                                                                undefined,
                                                            )), 1))
                                                        : (_openBlock(), _createElementBlock("td", _hoisted_74))
                                                    ])
                                                  ]),
                                                  _: 1
                                                }, 8, ["headers", "items", "loading"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_card_actions, { style: {"padding-right":"24px","padding-left":"24px"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          rounded: "",
                                          class: "ma-2",
                                          onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.previous(1))),
                                          color: 'secondary'
                                        }, {
                                          default: _withCtx(() => _cache[111] || (_cache[111] = [
                                            _createTextVNode(" Précédent ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          rounded: "",
                                          class: "ma-2",
                                          color: 'primary',
                                          onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.validateCreditNote())),
                                          disabled: _ctx.disabledValidateBtn
                                        }, {
                                          default: _withCtx(() => _cache[112] || (_cache[112] = [
                                            _createTextVNode(" Valider ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.displayActivityDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 8,
                      modelValue: _ctx.displayActivityDialog,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                      title: "Activité",
                      "valid-title": "Fermer",
                      onValid: _cache[43] || (_cache[43] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      onClose: _cache[44] || (_cache[44] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UsersActivitiesHistory, {
                          auditCheckKey: _ctx.acKey,
                          accountingPeriodId: _ctx.accountingPeriodId
                        }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_oss_dialog, {
                  modelValue: _ctx.miscellaneousOperationDialog,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
                  actions: _ctx.actionsMiscellaneousOperation,
                  "min-width": "90vw"
                }, {
                  default: _withCtx(() => [
                    (_ctx.miscellaneousOperationDialog)
                      ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                          key: 0,
                          companyId: _ctx.companyId,
                          prefilledRows: _ctx.miscellanousOperationData,
                          acKey: _ctx.acKey,
                          auditCheckResult: _ctx.auditCheckResult,
                          accountingPeriodId: _ctx.accountingPeriodId,
                          onUpsert: _cache[45] || (_cache[45] = ($event: any) => (_ctx.refresh())),
                          actions: _ctx.actionsMiscellaneousOperation
                        }, null, 8, ["companyId", "prefilledRows", "acKey", "auditCheckResult", "accountingPeriodId", "actions"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "actions"]),
                (_ctx.openChat)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 9,
                      auditCheckAccountingPeriodKey: _ctx.chatId,
                      chatTitle: 'Chat'
                    }, null, 8, ["auditCheckAccountingPeriodKey"]))
                  : _createCommentVNode("", true),
                (_ctx.dialogAuditCheckDocumentsManager)
                  ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                      key: 10,
                      modelValue: _ctx.dialogAuditCheckDocumentsManager,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                      disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                      companyId: _ctx.companyId,
                      documentToDisplay: _ctx.documentToDisplay,
                      connectedDocuments: _ctx.connectedDocuments || [],
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                      onUpsertedAuditCheckResult: _ctx.upsertedACR,
                      onResetDialogData: _cache[48] || (_cache[48] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                    }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ]),
    _: 1
  }))
}